import { useNavigate } from 'react-router-dom';
import { NavItem } from '../mf-utils';

export function useNavTo() {
  const navigate = useNavigate();

  return (navItem: NavItem) => {
    if (navItem.onClick) {
      navItem.onClick(navItem);
    } else if (navItem.route) {
      navigate(navItem.route);
    } else if (navItem.url) {
      window.open(navItem.url, '_blank');
    } else {
      console.error(
        '[useNavTo] navItem has no onClick, route nor url',
        navItem
      );
    }
  };
}
